import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  effect,
  inject,
} from '@angular/core';
import { Observable, Subject, UnaryFunction, pipe } from 'rxjs';
import { finalize, map, takeUntil } from 'rxjs/operators';

import {
  Desktop,
  GetEnumValuesDto,
  UserStateDto,
} from 'src/app/core/api/models';
import { EnumsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { PageConfig } from 'src/app/core/models/page-config.model';
import { PermissionService } from 'src/app/core/services/authentication/permission.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';

@Component({
    selector: 'app-base-form',
    template: ``,
    standalone: false
})
export abstract class BasePageComponent implements OnDestroy, OnInit {
  //#region Properties
  permissionService = inject(PermissionService);
  elementRef = inject(ElementRef);
  loggerService = inject(LoggerService);
  enumService = inject(EnumsService);
  cd = inject(ChangeDetectorRef);

  @Input('pageId') pageId: string;
  @Input() formPageConfig: FormPageConfig<any> = {};

  pageName: string;
  tagName: string;
  pageVocabs: string;
  pageConfig: PageConfig = {};
  title: string;
  desktop: Desktop;
  protected onDestroy$ = new Subject<void>();
  get desktopEnum() {
    return Desktop;
  }
  loading: boolean = false;
  currentUserInfo: UserStateDto = {};
  currentDateTime: string = new Date().toISOString();
  pageService: object;

  //#endregion

  constructor() {
    this.tagName = this.elementRef.nativeElement.tagName.toLowerCase();
    effect(() => {
      if (this.permissionService.userState()) {
      }
      this.getUserState();
    });
  }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.getUserState();
  }

  //#region Permission

  getUserState() {
    this.currentUserInfo = this.permissionService.userState();
  }

  //#endregion

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    try {
      if (SavedEnumsService.getEnum(enumName) != null)
        return SavedEnumsService.getEnumAsObservable(enumName);

      this.enumService
        .enumsGetEnumValues({ EnumTypeName: enumName })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((newEnum) => {
          SavedEnumsService.pushEnum({
            enumName: enumName,
            enumValue: newEnum?.data,
          });
        });

      // save enum
      return this.enumService
        .enumsGetEnumValues({ EnumTypeName: enumName })
        .pipe(
          takeUntil(this.onDestroy$),
          map((res) => res.data)
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  /** disable loading with <b>finalize</b> and unsubscribe when call ngOnDestroy with <b>takeUntil</b> and show response messages*/
  basePipeOperators = <T>() =>
    pipe(
      finalize(() => {
        this.loading = false;
        this.pageConfig.loading = false;
      }),
      takeUntil(this.onDestroy$)
    ) as UnaryFunction<Observable<T>, Observable<T>>;

  unSubs() {
    this.onDestroy$.next();
  }

  ngOnDestroy() {
    this.unSubs();
    this.onDestroy$.complete();
  }
}
